/**
 * Referral Link API for Service Providers
 * Feature: 012-care-seeker-invite-signup (T061)
 *
 * The endpoint is role-agnostic — it answers for a Service Provider and a
 * Financial Advisor alike — so the call itself lives in
 * `@/shared/api/referralLinkApi`. This module keeps the name its consumers use.
 */

import { fetchReferralLink } from '@/shared/api/referralLinkApi';

export type { ReferralLinkResponse } from '@/shared/api/referralLinkApi';

export const fetchProviderReferralLink = fetchReferralLink;
